import React from 'react';

type Props = {
    size?: {
        width: number;
        height: number;
    };
};

export const MenuDownIcon = ({size = {width: 24, height: 24}}: Props) => {
    return (
        <svg
            width={size.width}
            height={size.height}
            viewBox='0 0 24 24'
            fill='currentColor'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path d='M7,10L12,15L17,10H7Z' />
        </svg>
    );
};
